
























































import { Vue, Component, Ref } from "vue-property-decorator";
import { vxm } from "@/store";
import api from "@/plugins/api";
import { firestore } from "@/plugins/firebase";
import { addDoc, collection, doc, serverTimestamp, updateDoc } from "@firebase/firestore";

@Component({
  destroyed() {
    (this as Dev).running = false;
  }
})
export default class Dev extends Vue {
  @Ref("form") form: any;

  valid = false;
  teamNamePrefix = "Sim";
  numberOfTeams = 2;
  trackInterval = 10;
  answerInterval = 60;

  running = false;
  runningInterval = 0.1;
  teams: any[] = [];
  activeTeams = 0;
  interval: any = 0;

  numberOfTeamsRules = [
    (v: string) => !!v || "Please enter an integer",
    (v: string) => !/[^0-9-]/.test(v) || "Please enter an integer",
    (v: number) => (v >= 1 && v <= 1000) || "Please enter an integer between 1 and 1000"
  ];
  trackIntervalRules = [];
  answerIntervalRules = [];

  toggleRunning() {
    this.running = !this.running;

    if (this.running) {
      this.run();
    } else {
      clearTimeout(this.interval);
    }
  }

  get fluid() {
    return vxm.app.fluid;
  }

  get game() {
    return vxm.games.db[vxm.results.gameId];
  }

  async run() {
    // Manager number of teams
    if (this.teams.length < this.numberOfTeams) {
      const name = this.teamNamePrefix + this.teams.length;
      const registeredTeam = vxm.results.teams.find(t => t.name === name);
      const team: any = {
        lastTrackTime: Date.now() - Math.random() * this.trackInterval * 1000,
        lastAnswerTime: Date.now() - Math.random() * this.answerInterval * 1000
      };

      if (registeredTeam) {
        team.id = registeredTeam.id;
        ++this.activeTeams;
      } else {
        api
          .post("/v3/play/register", {
            gameId: vxm.results.gameId,
            name,
            instanceId: name + "instance",
            playerName: "Player"
          })
          .then(res => {
            team.id = res.data.teamId;

            if (this.activeTeams < this.numberOfTeams) {
              ++this.activeTeams;
            }
          });
      }

      this.teams.push(team);
    } else if (this.teams.length > this.numberOfTeams) {
      this.teams = this.teams.slice(0, this.numberOfTeams);
      this.activeTeams = this.numberOfTeams;
    }

    // Simulate activity
    const time = Date.now();

    for (const team of this.teams) {
      if (!team.id) {
        continue;
      }

      // Track
      if (time - team.lastTrackTime >= this.trackInterval * 1000) {
        addDoc(collection(firestore, `/events/${vxm.results.eventId}/track`), {
          teamId: team.id,
          time: serverTimestamp(),
          lat: Math.random() * 10,
          lng: Math.random() * 10,
          acc: 25
        }).then(() => {});

        team.lastTrackTime = time;
      }

      // Answers
      if (time - team.lastAnswerTime >= this.answerInterval * 1000) {
        updateDoc(doc(firestore, `/events/${vxm.results.eventId}/teams/${team.id}`), {
          odometer: Math.random() * 10,
          answersScore: Math.round(Math.random() * 50),
          totalScore: Math.round(Math.random() * 100)
        }).then(() => {});

        const answer = this.generateRandomAnswer(team.id);

        addDoc(collection(firestore, `/events/${vxm.results.eventId}/answers`), answer).then(() => {});

        team.lastAnswerTime = time;
      }
    }

    // Next
    if (this.running) {
      this.interval = setTimeout(() => this.run(), this.runningInterval * 1000);
    }
  }

  generateRandomAnswer(teamId: string) {
    const task = this.game.tasks[Math.floor(Math.random() * this.game.tasks.length)];

    const answer: any = {
      time: serverTimestamp(),
      teamId: teamId,
      taskId: task.id,
      skipped: false,
      timeToAnswer: Math.ceil(Math.random() * 120),
      hintUsed: Math.random() > 0.8
    };

    answer.outOfTime = task.timeLimit ? answer.timeToAnswer > task.timeLimit : false;

    if (answer.outOfTime) {
      answer.correct = false;
    } else {
      switch (task.answerType) {
        default:
          answer.correct = true;
          answer.score = task.difficulty;
          break;
        case "activity":
          answer.score = Math.round(Math.random() * task.difficulty);
          answer.correct = answer.score > 0;
          break;
        case "photo":
        case "augmentedRealityPhoto": {
          answer.correct = true;
          answer.score = task.difficulty;
          answer.medium = task.id; // firebase.firestore().collection(`media`).doc().id;
          break;
        }
        case "video": {
          answer.correct = true;
          answer.score = task.difficulty;
          answer.medium = task.id;
          break;
        }
        case "multiple":
          answer.options = task.answers.map((answer, i) => i).filter(() => Math.random() > 0.5);

          answer.correct =
            !answer.options.find((i: number) => !task.answers[i].correct) &&
            answer.options.length === task.answers.filter(option => option.correct).length;

          answer.score = answer.correct ? task.difficulty : 0;
          break;
        case "single":
          answer.option = Math.floor(Math.random() * task.answers.length);
          answer.correct = answer.option === task.answers.findIndex(option => option.correct);
          answer.score = answer.correct ? task.difficulty : 0;
          break;
        case "number": {
          const v = parseInt(task.answers[0].text);
          answer.value = v + 2 - Math.floor(Math.random() * 5);
          answer.correct = answer.value === v;
          answer.score = answer.correct ? task.difficulty : 0;
          break;
        }
        case "number:range": {
          const r = task.answers[0].text.split("-").map(value => parseInt(value.trim()));
          answer.value = r[0] + Math.floor(Math.random() * (r[1] - r[0] + 1));
          answer.value += 2 - Math.floor(Math.random() * 5);
          answer.correct = answer.value >= r[0] && answer.value <= r[1];
          answer.score = answer.correct ? task.difficulty : 0;
        }
        case "text": {
          const options = task.answers.map(answer => answer.text).concat(["hello", "random", "probably wrong"]);

          answer.text = options[Math.floor(Math.random() * options.length)];
          answer.correct = answer.text === options[0];
          answer.score = answer.correct ? task.difficulty : 0;
        }
      }

      if (task.survey) {
        answer.correct = true;
      }
    }

    return answer;
  }
}
